(function () {
  const footerSections = document.querySelectorAll('.main-footer__section-toggle');
  
  if (!footerSections.length) return;

  footerSections.forEach((toggle) => {
    const sectionId = toggle.getAttribute('aria-controls');
    const content = document.getElementById(sectionId);
    
    if (!content) return;

    // Set initial ARIA attributes
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    content.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');

    toggle.addEventListener('click', () => {
      const isCurrentlyExpanded = toggle.getAttribute('aria-expanded') === 'true';
      const newExpandedState = !isCurrentlyExpanded;

      toggle.setAttribute('aria-expanded', newExpandedState);
      content.setAttribute('aria-hidden', newExpandedState ? 'false' : 'true');
    });
  });
})();
